import { transformValue } from 'helpers';
import { KeyboardEvent, useState } from 'react';
import AutosizeInput from 'react-input-autosize';
import { FunnelInputElement } from './FunnelInput.styles';

export default function FunnelInput({
    autoFocus,
    decimals = 0,
    disabled,
    placeholder = '##',
    min,
    max,
    multiplier = 1,
    size = 18,
    value,
    onChange,
}: FunnelInputProps) {

    const [val, setVal] = useState<number>(0);

    function handleIsAllowed(values: FunnelInputElementValues) {
        let newVal = values.floatValue ? (values.floatValue / multiplier) : 0;
        if (newVal && min !== undefined) {
            newVal = Math.max(newVal, min);
        }
        if (newVal && max !== undefined) {
            newVal = Math.min(newVal, max);
        }
        setVal(newVal);
        return true;
    }

    function handleKeyDown(e: KeyboardEvent) {
        if (e.key === 'Enter') {
            onChange(val);
        }
    }

    return <FunnelInputElement
        $size={size}
        autoFocus={autoFocus}
        customInput={AutosizeInput}
        decimalScale={decimals}
        disabled={disabled}
        placeholder={placeholder}
        thousandSeparator
        value={value === undefined ? '' : transformValue(value, multiplier, decimals).toFixed(decimals)}
        isAllowed={handleIsAllowed}
        onBlur={() => onChange(val)}
        onKeyDown={handleKeyDown}
    />;

}
